import axios from 'axios';
import { API_CONFIG } from '../config/api';

const api = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout || 30000,
  headers: API_CONFIG.headers,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const referralService = {
  list: async (params = {}) => {
    const response = await api.get('/referrals', { params });
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/referrals', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.patch(`/referrals/${id}`, data);
    return response.data;
  },
  remove: async (id) => {
    const response = await api.delete(`/referrals/${id}`);
    return response.data;
  },
};

export default referralService;
